import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

const NotFound = () => {
  return (
    <Box textAlign="center" py={10} px={6}>
      <Heading as="h1" size="2xl" mb={4}>
        404
      </Heading>
      <Text fontSize="lg" color="gray.600">
        Oops! The page you're looking for Is UnderConstruction.
      </Text>
    </Box>
  );
};

export default NotFound;
